import React from "react";

export const SyncForPayablesIcon: React.FC = () => {
  return (
    <svg
      data-testid="sync-for-payables-icon"
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_1530_654)">
        <g clipPath="url(#clip0_1530_654)">
          <rect x="3" y="2" width="48" height="48.0001" rx="8" fill="#FF99DF" />
          <rect
            x="35.123"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 35.123 2)"
            fill="#851651"
          />
          <rect
            x="38.6738"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 38.6738 2)"
            fill="#851651"
          />
          <rect
            x="31.5723"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 31.5723 2)"
            fill="#851651"
          />
          <rect
            x="24.4727"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 24.4727 2)"
            fill="#851651"
          />
          <rect
            x="20.9238"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 20.9238 2)"
            fill="#851651"
          />
          <rect
            x="17.373"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 17.373 2)"
            fill="#851651"
          />
          <rect
            x="51"
            y="34.127"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 34.127)"
            fill="#851651"
          />
          <rect
            x="51"
            y="37.6758"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 37.6758)"
            fill="#851651"
          />
          <rect
            x="51"
            y="30.5762"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 30.5762)"
            fill="#851651"
          />
          <rect
            x="51"
            y="23.4766"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 23.4766)"
            fill="#851651"
          />
          <rect
            x="51"
            y="19.9258"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 19.9258)"
            fill="#851651"
          />
          <rect
            x="51"
            y="16.375"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 16.375)"
            fill="#851651"
          />
          <g filter="url(#filter1_di_1530_654)">
            <rect
              x="7"
              y="6"
              width="40"
              height="40.0001"
              rx="6"
              fill="#1A0044"
            />
            <rect
              x="7.24859"
              y="6.24859"
              width="39.5028"
              height="39.5029"
              rx="5.75141"
              stroke="black"
              strokeOpacity="0.2"
              strokeWidth="0.49718"
            />
          </g>
          <path
            d="M31.6673 31.8327L35.1673 35.3327M35.1673 35.3327L38.6673 31.8327M35.1673 35.3327V28.3327M38.6673 22.4994H15.334M38.6673 24.8327V20.3994C38.6673 19.0926 38.6673 18.4392 38.413 17.94C38.1893 17.501 37.8324 17.144 37.3933 16.9203C36.8942 16.666 36.2408 16.666 34.934 16.666H19.0673C17.7605 16.666 17.1071 16.666 16.608 16.9203C16.169 17.144 15.812 17.501 15.5883 17.94C15.334 18.4392 15.334 19.0926 15.334 20.3994V29.266C15.334 30.5728 15.334 31.2262 15.5883 31.7253C15.812 32.1644 16.169 32.5213 16.608 32.745C17.1071 32.9994 17.7605 32.9994 19.0673 32.9994H27.0007"
            stroke="white"
            strokeWidth="1.7846"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <rect
          x="3.21818"
          y="2.21818"
          width="47.5636"
          height="47.5637"
          rx="7.78182"
          stroke="black"
          strokeOpacity="0.2"
          strokeWidth="0.436364"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_1530_654"
          x="0.745718"
          y="0.497145"
          width="52.5086"
          height="52.5086"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="0.751427"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_1530_654"
          />
          <feOffset dy="0.751427" />
          <feGaussianBlur stdDeviation="0.751427" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1530_654"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.751427" />
          <feGaussianBlur stdDeviation="1.12714" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_1530_654"
            result="effect2_dropShadow_1530_654"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_1530_654"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_di_1530_654"
          x="3"
          y="3"
          width="48"
          height="48"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1530_654"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1530_654"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.99436" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_1530_654"
          />
        </filter>
        <clipPath id="clip0_1530_654">
          <rect x="3" y="2" width="48" height="48.0001" rx="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
